/*=========================================================================================
  File Name: index.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import jwt from 'jsonwebtoken'
import store from '../store/store'
import VueCookie from 'vue-cookie'

import routerProject from './router-project'
import routerMain from './router-main'
import routerBoards from './boards'
import routerFields from './fields'
import routerFilelibrary from './filelibrary'
import PrintMemberPage from "@/views/boards/single-page/1007/PrintMemberPage.vue";

Vue.use(Router)

/**
 * 권한 체크
 * @returns {function(*, *, *): (*)}
 */
async function requireAuth (to, from, next) {

  let userToken = store.state.auth.userToken
  let isAuthenticated = false

  if (!userToken || userToken === '') {
    userToken = VueCookie.get('token')
  }
  if (userToken) {
    try {
      // jwt.decode 로 만료 기간 체크 (exp)
      const decToken = jwt.decode(userToken)
      const currentTime = new Date().getTime() / 1000

      if (currentTime < decToken.exp) {
        isAuthenticated = true
      }

      // eslint-disable-next-line no-empty
    } catch (err) {

    }
  } else {
    VueCookie.delete('token') // 현재 토큰 제거
    VueCookie.delete('current_id') // 현재 보고있는 게시물 넘버
  }

  // 게스트도 볼 수 있는가? 체크
  // api 제작필요.

  // 게스트는 볼 수 없는 경우
  // 내가 보려고하는 페이지에 권한이 있는가 체크
  // 나의 권한 가져오기 api 제작필요

  if (!isAuthenticated) {
    await store.dispatch('REFRESH_TOKEN').catch(err => {
      // 토큰 갱신 실패 시 로그인 페이지로 리다이렉트
      // 에러 메시지는 표시하지 않음 (라우터 가드에서는 조용히 처리)
      VueCookie.set('LOGIN_TO_FULLPATH', to.fullPath) // 로그인 후 이동할 페이지
      VueCookie.delete('token') // 현재 토큰 제거
      VueCookie.delete('current_id') // 현재 보고있는 게시물 넘버
      return next('/login')
    })
  }
  await store.dispatch('USER_INFO')

}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    ...routerProject,
    ...routerMain,
    ...routerBoards,
    ...routerFields,
    ...routerFilelibrary,
    {
      path: '',
      component: () => import('@/layouts/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES - WEB
        // =============================================================================
        // login
        {
          path: '/login',
          name: 'page-login',
          component: () => import('@/views/pages/login/Login.vue'),
          meta:{
            deviceRequired: true
          }
        },
        // ===== sso login=====
        {
          path: '/login/sso',
          name: 'login-sso',
          component: () => import('@/views/pages/login/Sso.vue')
        },

        {
          path: '/reset-password',
          name: 'page-reset-password',
          component: () => import('@/views/pages/login/ResetPassword.vue')
        },
        {
          path: '/forgot-password',
          name: 'page-forgot-password',
          component: () => import('@/views/pages/login/ForgotPassword.vue')
        },
        {
          path: '/register',
          name: 'page-register',
          component: () => import('@/views/pages/register/Register.vue')
        },
        {
          path: '/print',
          name: 'page-print',
          component: () => import('@/views/pages/Print.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        // =============================================================================
        // 1007 - 날인부인쇄
        {
          path: '/print-member',
          name: 'print-member',
          component: PrintMemberPage
        },
      ]
    },

    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ]
})


router.beforeEach((to, from, next) => {
  const checkAuthRequired = to.matched.some(r => r.meta.authRequired)
  const checkMobile = to.matched.some(r => r.meta.deviceRequired)

  // 유지보수 페이지 또는 정적 리소스 접근 시 체크 제외
  if (to.path.includes('maintenance.html')) {
    return next()
  }

  function checkMaintenance() {
    fetch('/maintenance-status.json?v=' + Date.now())
      .then(res => res.json())
      .then(status => {
        const now = Date.now()
        const start = status.scheduled && new Date(status.scheduled.start).getTime()
        const end = status.scheduled && new Date(status.scheduled.end).getTime()
        const isScheduled = start && end && now >= start && now < end

        // 점검 모드
        if (status.maintenance || status.scheduledEnabled && isScheduled) {
          // vue-router 경로가 아니라 브라우저 직접 이동해야 안정적
          window.location.replace('/maintenance.html')
          return
        }

        continueRouting()
      })
      .catch(() => continueRouting())
  }

  function continueRouting() {
    if (checkAuthRequired) {
      // requireAuth에서 next 호출 대신 boolean 상태 반환하도록 설계 권장
      requireAuth(to, from, next)
    }

    // if (checkMobile) return requireMobile(to, from, next)

    next() // 🎯 여기서만 next() 호출
  }

  checkMaintenance()
})



router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

// window resize 체크
const updateSizes = (obj = {}) => {
  obj.width = window.innerWidth
  obj.height = window.innerHeight
  obj.screens = ['sm', 'md', 'lg', 'xl', 'xxl']
  if (obj.width >= 1440) obj.screen = 'xxl'
  else if (obj.width >= 1200) obj.screen = 'xl'
  else if (obj.width >= 992) obj.screen = 'lg'
  else if (obj.width >= 768) obj.screen = 'md'
  else if (obj.width >= 576) obj.screen = 'sm'
  else obj.screen = 'xs'
  // mobile 체크
  obj.isMobile = obj.width < 1200
  return obj
}
Object.defineProperty(Vue.prototype, '$viewport', {
  value: Vue.observable(updateSizes())
})
window.addEventListener('resize', (e) => {
  updateSizes(Vue.prototype.$viewport)
})

export default router
